import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questions-table";

const keys = addTranslations(RESOURCE_NAME, {
    question: {
        en: "Question",
        fr: "Question",
    },
    group: {
        en: "Section",
        fr: "Section",
    },
    questionnaire: {
        en: "Questionnaire",
        fr: "Questionnaire",
    },
    question_not_translated: {
        en: "Question not translated in the selected locale",
        fr: "Question non traduite dans la langue sélectionnée",
    },
    group_not_translated: {
        en: "No translation",
        fr: "Aucune traduction",
    },
    empty_state_title: {
        en: "Get Started with Supplier Evaluations",
        fr: "Commencer avec les évaluations des fournisseurs",
    },
    empty_state_sub_title: {
        en: "Create and manage evaluation questions to ensure your suppliers meet your standards. You haven’t created any questions yet, but it’s easy to get started!",
        fr: "Créez et gérez les questions d'évaluation pour garantir que vos fournisseurs répondent à vos normes. Vous n'avez pas encore créé de questions, mais c'est facile à commencer !",
    },
    empty_state_title_with_questionnaire: {
        en: "No questions found",
        fr: "Aucune question trouvée",
    },
    empty_state_sub_title_with_questionnaire: {
        en: "Create a new question by clicking on the button above",
        fr: "Créez une nouvelle question en cliquant sur le bouton ci-dessus",
    },
    toast_error_update_question: {
        en: "There was an error updating the question",
        fr: "Il y a eu une erreur lors de la mise à jour de la question",
    },
    toast_success_update_question: {
        en: "Question updated successfully",
        fr: "Question mise à jour avec succès",
    },
    toast_error_update_question_other: {
        en: "There was an error updating the questions",
        fr: "Il y a eu une erreur lors de la mise à jour des questions",
    },
    toast_success_update_question_other: {
        en: "Questions updated successfully",
        fr: "Questions mises à jour avec succès",
    },
    delete_question: {
        en: "Delete",
        fr: "Supprimer",
    },
    toast_error_delete_question: {
        en: "There was an error deleting the question",
        fr: "Il y a eu une erreur lors de la suppression de la question",
    },
    toast_error_delete_question_one: {
        en: "There was an error deleting the question",
        fr: "Il y a eu une erreur lors de la suppression de la question",
    },
    toast_error_delete_question_other: {
        en: "There was an error deleting the questions",
        fr: "Il y a eu une erreur lors de la suppression des questions",
    },
    toast_success_delete_question: {
        en: "Question deleted successfully",
        fr: "Question supprimée avec succès",
    },
    toast_success_delete_question_one: {
        en: "Question deleted successfully",
        fr: "Question supprimée avec succès",
    },
    toast_success_delete_question_other: {
        en: "Questions deleted successfully",
        fr: "Questions supprimées avec succès",
    },
    edit_question: {
        en: "Edit",
        fr: "Modifier",
    },
    insert_above: {
        en: "Insert above",
        fr: "Insérer au-dessus",
    },
    insert_below: {
        en: "Insert below",
        fr: "Insérer au-dessous",
    },
    delete_question_modal_title: {
        en: "Delete Question",
        fr: "Supprimer la question",
    },
    delete_question_modal_title_one: {
        en: "Delete Question",
        fr: "Supprimer la question",
    },
    delete_question_modal_title_other: {
        en: "Delete Questions",
        fr: "Supprimer les questions",
    },
    delete_question_modal_body: {
        en: "Are you sure you want to delete this question? This action is irreversible. Please note, the question will still appear in any questionnaires that have already been sent.",
        fr: "Êtes-vous sûr de vouloir supprimer cette question ? Cette action est irréversible. Veuillez noter que la question apparaîtra encore dans tous les questionnaires qui ont déjà été envoyés.",
    },
    delete_question_modal_body_one: {
        en: "Are you sure you want to delete this question? This action is irreversible. Please note, the question will still appear in any questionnaires that have already been sent.",
        fr: "Êtes-vous sûr de vouloir supprimer cette question ? Cette action est irréversible. Veuillez noter que la question apparaîtra encore dans tous les questionnaires qui ont déjà été envoyés.",
    },
    delete_question_modal_body_other: {
        en: "Are you sure you want to delete {{count}} questions? This action is irreversible. Please note, the questions will still appear in any questionnaires that have already been sent.",
        fr: "Êtes-vous sûr de vouloir supprimer {{count}} questions ? Cette action est irréversible. Veuillez noter que les questions apparaîtront encore dans tous les questionnaires qui ont déjà été envoyés.",
    },
    delete_question_modal_cancel_button: {
        en: "Cancel",
        fr: "Annuler",
    },
    delete_question_modal_confirm_button: {
        en: "Delete",
        fr: "Supprimer",
    },
    action_bar_selected_questions: {
        en: "Selected questions",
        fr: "Questions sélectionnées",
    },
    action_bar_selected_questions_one: {
        en: "One question selected",
        fr: "Une question sélectionnée",
    },
    action_bar_selected_questions_other: {
        en: "{{count}} selected questions",
        fr: "{{count}} questions sélectionnées",
    },
    action_bar_select_action: {
        en: "Select action",
        fr: "Sélectionner une action",
    },
    action_bar_assign_questionnaire: {
        en: "Assign questionnaire",
        fr: "Assigner un questionnaire",
    },
    action_bar_assign_questionnaire_one: {
        en: "Assign questionnaire to one question",
        fr: "Assigner un questionnaire à une question",
    },
    action_bar_assign_questionnaire_other: {
        en: "Assign questionnaire to {{count}} questions",
        fr: "Assigner un questionnaire à {{count}} questions",
    },
    action_bar_assign_question_group: {
        en: "Assign section",
        fr: "Assigner une section",
    },
    action_bar_assign_question_group_one: {
        en: "Assign section to one question",
        fr: "Assigner une section à une question",
    },
    action_bar_assign_question_group_other: {
        en: "Assign section to {{count}} questions",
        fr: "Assigner une section à {{count}} questions",
    },
    action_bar_delete_question: {
        en: "Delete questions",
        fr: "Supprimer les questions",
    },
    apply_action: {
        en: "Apply",
        fr: "Appliquer",
    },

    table_question_type_text: {
        en: "Text",
        fr: "Texte",
    },
    table_question_type_value: {
        en: "Value",
        fr: "Valeur",
    },
    table_question_type_single_select: {
        en: "Single choice",
        fr: "Choix unique",
    },
    table_question_type_multi_select: {
        en: "Multiple choice",
        fr: "Choix multiple",
    },
    modal_toast_error_create_question_group: {
        en: "There was an error creating the question section",
        fr: "Il y a eu une erreur lors de la création de la section de questions",
    },
});

export function useSupplierQuestionsTableTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
